import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {Router} from '@angular/router';
import {Observable, Subscription} from 'rxjs';

import {MenuItem} from '@models/sidebar/menu-item';
import {ToggleFavoriteService} from '@services/left-menu/favorites/toggle-favorite/toggle-favorite.service';
import {SelectPageService} from '@services/left-menu/select-page/select-page.service';
import {StorageService} from '@services/storage/storage.service';
import {LeftMenuService} from '@services/left-menu/left-menu.service';

@Component({
    selector: 'scitis-node-detail',
    templateUrl: './node-detail.component.html',
    styleUrls: ['./node-detail.component.scss'],
    standalone: false
})
export class NodeDetailComponent implements OnInit, OnDestroy, OnChanges {

  @Input()
  nodeUserMenuItems: MenuItem[] = [];

  @Input()
  showNodeUserMenuItems: boolean = false;

  @Input()
  firebaseUserId: string = '';

  @Input()
  interactiveDataAnalysisItemToRedirect: MenuItem | undefined;

  private SELECTED_PAGE_KEY = '';
  private subscription: Subscription = new Subscription();

  constructor(
      private router: Router,
      private toggleFavoriteService: ToggleFavoriteService,
      private selectPageService: SelectPageService,
      private storageService: StorageService,
      private leftMenuService: LeftMenuService) {
  }

  get folderIsEmpty(): boolean {
    return this.nodeUserMenuItems.length <= 0;
  }

  getClass(menuItem: MenuItem): string {
    let className = '';
    if (String(menuItem.id) === String(this.selectPageService.getSelectedPageId)) {
      className = ' scitis-menu-item-active';
    }
    return className;
  }

  ngOnInit() {
    this.subscription = this.toggleFavoriteService.removeFavoriteItem
    .subscribe((removedFavoriteMenuItem: MenuItem) => {
      this.nodeUserMenuItems.forEach((item: MenuItem) => {
        if (String(removedFavoriteMenuItem.id) === String(item.id)) {
          item.isFavorite = false;
        }
      });
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.firebaseUserId && changes.firebaseUserId.currentValue !== -1) {
      this.SELECTED_PAGE_KEY = 'selectedPage' + this.firebaseUserId;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onClick(event, item: MenuItem): void {
    event.preventDefault();
    const commands = this.leftMenuService.getCommands(item, this.firebaseUserId, this.interactiveDataAnalysisItemToRedirect);
    this.leftMenuService.navigateToPage(commands);
    this.selectPageService.setSelectedPageId(item.id);
    this.storageService.writeValueToIndexedDb(this.SELECTED_PAGE_KEY, item.id);
  }

  toggleFavorite(event: any, item: MenuItem): void {
    this.toggleFavoriteService.toggleFavorite(event, item, this.firebaseUserId);
  }

  getTooltip(item: MenuItem): Observable<string> {
    return this.toggleFavoriteService.getTooltip(item);
  }

}
